import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Like = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 12}
      height={size ?? 12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19501 9.24499V4.16499C4.19501 3.96499 4.25501 3.76999 4.36501 3.60499L5.73001 1.57499C5.94501 1.24999 6.48001 1.01999 6.93501 1.18999C7.42501 1.35499 7.75001 1.90499 7.64501 2.39499L7.38501 4.02999C7.36501 4.17999 7.40501 4.31499 7.49001 4.41999C7.57501 4.51499 7.70001 4.57499 7.83501 4.57499H9.89001C10.285 4.57499 10.625 4.73499 10.825 5.01499C11.015 5.28499 11.05 5.63499 10.925 5.98999L9.69501 9.73499C9.54001 10.355 8.86501 10.86 8.19501 10.86H6.24501C5.91001 10.86 5.44001 10.745 5.22501 10.53L4.58501 10.035C4.34001 9.84999 4.19501 9.55499 4.19501 9.24499Z"
        fill={color}
      />
      <path
        d="M2.605 3.19H2.09C1.315 3.19 1 3.49 1 4.23V9.26C1 10 1.315 10.3 2.09 10.3H2.605C3.38 10.3 3.695 10 3.695 9.26V4.23C3.695 3.49 3.38 3.19 2.605 3.19Z"
        fill={color}
      />
    </svg>
  );
});

export default Like;
